/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orange_Merry_Jackal_DreamInputs */

const en_orange_merry_jackal_dream = /** @type {(inputs: Orange_Merry_Jackal_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No detractors`)
};

const de_orange_merry_jackal_dream = /** @type {(inputs: Orange_Merry_Jackal_DreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Detraktoren`)
};

/**
* | output |
* | --- |
* | "No detractors" |
*
* @param {Orange_Merry_Jackal_DreamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const orange_merry_jackal_dream = /** @type {((inputs?: Orange_Merry_Jackal_DreamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orange_Merry_Jackal_DreamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orange_merry_jackal_dream(inputs)
	return de_orange_merry_jackal_dream(inputs)
});